// NEU-LAB: tema neumorfico do painel de Conversas (so no tema claro).
// LIGADO por padrao desde 2026-07-25; `?neu=0` desliga sem rebuild.
// Lido no IMPORT do modulo, nao em hook: sobrevive as reescritas da URL
// (reflexo do ?panel=) e nao vira hook condicional depois de um early return.
export const NEU = typeof window !== 'undefined' &&
  new URLSearchParams(window.location.search).get('neu') !== '0'
